import React from "react";

import { NamedRoute } from "@/jenesys-types/routes/routes";

import { CompanyPractiseProfileEditRoute } from "@/components/routes/settings/CompanyPractiseProfileEditRoute";
import { CompanyPractiseProfileRoute } from "@/components/routes/settings/CompanyPractiseProfileRoute";

// eslint-disable-next-line import/no-anonymous-default-export
export default (): NamedRoute => ({
  name: "settings.company.configuration",
  path: "practise-profile",
  children: [
    { index: true, element: <CompanyPractiseProfileRoute /> },
    {
      path: "edit",
      name: "settings.company.configuration.edit",
      element: <CompanyPractiseProfileEditRoute />
    }
  ]
});
